const typeToPayloadMap = {
  AdultRequiredBusinessRule: null,
  AgeConstrainedBusinessRule: [{ age: 22, constraint_type: 'min', applicant_type: 'child' }],
  AllowedRelationships: [{ relationship: 'adopted_child', same_household: false }],
  DomesticPartnerClassification: { secondary_subscriber: true },
  DomesticPartnerSameSexClassification: { secondary_subscriber: true },
  EligibleChildrenCap: { max_age_of_child: 20, eligible_children_cap: 3 },
  EnrolleeSize: [{ group_size_max: 9, group_size_min: 2, enrollee_size_min: 2 }],
  GroupSize: [{ min: 2, max: 9, state_codes: [] }],
  MaximumAgeDependent: { age: 29 },
  MembersInServiceArea: { 'required?': true },
  MembersQuotableInServiceArea: null,
  MembersQuotableInStateOnly: null,
  MinimumContributionPercentage: [{ minimum_percentage: 100, group_size_min: 2, group_size_max: 9 }],
  MinimumInStatePercentage: { minimum_percentage: 50 },
  MinimumMultiStateResidencyPercentage: { minimum_percentage: 50, allowed_states: [] },
  MinimumParticipationPercentage: [{ minimum_percentage: 100, group_size_min: 2, group_size_max: 9 }],
  NonEligibleChildRateAdjustment: { noneligible_children_additional_rate: 2.00 },
  RatingMethod: { rating_method: 'age_banded' },
  SicCodes: { code_type: 'ineligible', sic_codes: ['0001', '0002'] },
  SicCodesByCriteria: {
    code_type: 'ineligible',
    sic_codes: ['0001', '0002'],
    plan_criteria: '24_hour',
    criteria_value: false
  },
  TobaccoCutoff: { months: 6 }
}

export default typeToPayloadMap
